import AccountCreateForm from './AccountCreateForm'

export default AccountCreateForm
// eslint-disable-next-line import/export
export * from './AccountCreateForm'
